/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Notfound1Inputs */

const id_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build tidak ditemukan`)
};

const ms_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaan tidak ditemui`)
};

const da_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build ikke fundet`)
};

const de_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build nicht gefunden`)
};

const en_us2_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build not found`)
};

const es_es2_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación no encontrada`)
};

const es_mx2_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación no encontrada`)
};

const fil_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nahanap ang build`)
};

const fr_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilation non trouvée`)
};

const it_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build non trovata`)
};

const hu_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build nem található`)
};

const nl_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build niet gevonden`)
};

const no_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build ikke funnet`)
};

const pl_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompilacja nie znaleziona`)
};

const pt_br2_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build não encontrada`)
};

const pt_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilação não encontrada`)
};

const ro_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilare negăsită`)
};

const fi_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koontiversiota ei löydy`)
};

const sv_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bygget hittades inte`)
};

const vi_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy bản dựng`)
};

const tr_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapı bulunamadı`)
};

const cs_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sestavení nenalezeno`)
};

const bg_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компилацията не е намерена`)
};

const ru_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сборка не найдена`)
};

const uk_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Збірку не знайдено`)
};

const ar_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البنية غير موجودة`)
};

const hi_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिल्ड नहीं मिला`)
};

const th_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบบิลด์`)
};

const ja_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビルドが見つかりません`)
};

const zh_cn2_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`构建版本未找到`)
};

const zh_hant1_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建置版本未找到`)
};

const ko_builds_notfound1 = /** @type {(inputs: Builds_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빌드를 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "Build not found" |
*
* @param {Builds_Notfound1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_notfound1 = /** @type {((inputs?: Builds_Notfound1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Notfound1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_notfound1(inputs)
	if (locale === "ms") return ms_builds_notfound1(inputs)
	if (locale === "da") return da_builds_notfound1(inputs)
	if (locale === "de") return de_builds_notfound1(inputs)
	if (locale === "en-US") return en_us2_builds_notfound1(inputs)
	if (locale === "es-ES") return es_es2_builds_notfound1(inputs)
	if (locale === "es-MX") return es_mx2_builds_notfound1(inputs)
	if (locale === "fil") return fil_builds_notfound1(inputs)
	if (locale === "fr") return fr_builds_notfound1(inputs)
	if (locale === "it") return it_builds_notfound1(inputs)
	if (locale === "hu") return hu_builds_notfound1(inputs)
	if (locale === "nl") return nl_builds_notfound1(inputs)
	if (locale === "no") return no_builds_notfound1(inputs)
	if (locale === "pl") return pl_builds_notfound1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_notfound1(inputs)
	if (locale === "pt") return pt_builds_notfound1(inputs)
	if (locale === "ro") return ro_builds_notfound1(inputs)
	if (locale === "fi") return fi_builds_notfound1(inputs)
	if (locale === "sv") return sv_builds_notfound1(inputs)
	if (locale === "vi") return vi_builds_notfound1(inputs)
	if (locale === "tr") return tr_builds_notfound1(inputs)
	if (locale === "cs") return cs_builds_notfound1(inputs)
	if (locale === "bg") return bg_builds_notfound1(inputs)
	if (locale === "ru") return ru_builds_notfound1(inputs)
	if (locale === "uk") return uk_builds_notfound1(inputs)
	if (locale === "ar") return ar_builds_notfound1(inputs)
	if (locale === "hi") return hi_builds_notfound1(inputs)
	if (locale === "th") return th_builds_notfound1(inputs)
	if (locale === "ja") return ja_builds_notfound1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_notfound1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_notfound1(inputs)
	return ko_builds_notfound1(inputs)
});
export { builds_notfound1 as "builds.notFound" }